<ef-accounts-receivable-contract
    [accounts]="accountItems"
    [items]="contracts"
    [selectedError]="selectedError"
    (ShowError)="ShowError.next($event)"
    (SaveAccountContract)="onSaveAccountContract($event)"
></ef-accounts-receivable-contract>
